import React, { useContext, useEffect } from "react";
import { CartContext } from "context/cart";
import navigate from "@helpers/link-navigate";
import { trackAddToCart, trackViewCollection, trackSelectItem } from "analytics";
import formatVehicleType from "helpers/format-vehicle-type";
import { useLocation } from "@reach/router";
import CollectionItem from "@root/_components/collection-item";
import CollectionHeader from "./header";
import ProductItem from "./product";

const Collection = ({ data, variantColors, params: { handle, year } }) => {
    const { products } = data;
    const { addCartItem } = useContext(CartContext);

    const currentLocation = useLocation();

    const getCollectionTitle = () => {
        const vehicleType = products[0]?.vehicle_type;
        if (vehicleType) {
            const type = products[0]?.vehicle_subtype === "generic" ? formatVehicleType(vehicleType) : formatVehicleType(products[0]?.vehicle_subtype);

            return `${products[0]?.checkout_attributes?.FITS} ${type} Covers`;
        }

        return products[0]?.collection_title;
    };

    const getCollectionSlug = () => `${handle}${year ? `-${year}` : ""}`;

    useEffect(() => {
        if (products && products.length > 0) {
            trackViewCollection(products, getCollectionTitle(), getCollectionSlug());
        }
    }, [products]);

    const handleAddToCart = async (variantId, quantity, customAttributes) => {
        const hasFits = customAttributes.find((attribute) => attribute.key === "FITS");

        const product = products.find((productItem) => productItem.variants.edges.find((variant) => variant.node.id === variantId));

        const baseCustomAttributes = hasFits ? customAttributes : [...customAttributes, { key: "FITS", value: product?.productType || product?.handle }];

        await addCartItem([{
            variantId, quantity, customAttributes: baseCustomAttributes,
        }]);

        // ToDo: Refactor to be the same format everywhere, currently we are just injecting the current variant into the product object
        const _variant = product.variants.edges.find((variant) => variant.node.id === variantId);
        _variant.node.title = _variant?.node?.selectedOptions?.[0]?.value;

        trackAddToCart({
            ...product,
            quantity,
            variant: product?.currentVariant?.node ?? _variant.node,
        }, { prevUrl: currentLocation?.state?.prevUrl });

        navigate("/cart");
    };

    const handleSelectItem = (products) => {
        trackSelectItem(products, getCollectionTitle(), getCollectionSlug());
    };

    const isNewDesign = false // ["car", "boat"].includes(products[0]?.vehicle_type);

    return (
        <div className="container mb-12">
            <CollectionHeader products={products} isNewCollectionPageDesign={isNewDesign} />
            {products && (
                <div className={`w-full ${isNewDesign ? "collection-grid" : ""}`}>
                    {products.map((productItem) => (isNewDesign ? (
                        <CollectionItem
                            data={productItem}
                            key={productItem?.handle}
                            handleAddToCart={handleAddToCart}
                            variantColors={variantColors}
                            handleSelectItem={() => handleSelectItem(productItem)}
                        />
                    ) : (  
                        <ProductItem
                            data={productItem}
                            key={productItem?.handle}
                            handleAddToCart={handleAddToCart}
                            variantColors={variantColors}
                            handleSelectItem={() => handleSelectItem(productItem)}
                        />
                    )))}
                </div>
            )}
        </div>
    );
};

export default Collection;
